import axios from "../api/axios-admin-auth";

class GiftcardService {
    getGiftCardList() {
      return axios.get("/admin/gift-card-catalog");
    }
    createGiftCardOrder(data) {
      return axios.post("/admin/card-v2", data);
    }
    getCardCreatedByDetails(startDate, endDate, clientID, includeIWTxn) {
      return axios.get("/admin/created-by", {
        params: { startDate, endDate, clientID, includeIWTxn },
      });
    }
    
}
  
export default new GiftcardService();